export function groupByInitial(brandList) {
  const letterGroupList = {};

  brandList.forEach((name) => {
    const isLetter = /^[A-Za-z]$/.test(name.charAt(0));
    const group = isLetter ? name.charAt(0).toUpperCase() : "#";

    if (!letterGroupList[group]) {
      letterGroupList[group] = [];
    }

    letterGroupList[group].push(name);
  });

  return Object.keys(letterGroupList)
    .sort()
    .map((letter) => ({
      letter: letter,
      list: letterGroupList[letter]
    }));
}
